import * as React from 'react';
import { StyledButtonGroup } from './ButtonGroup.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultElement = 'div';
function ButtonGroup(props, ref) {
  const {
    as = defaultElement,
    fullWidth,
    direction = 'row',
    // box props
    p = '16px',
    ...htmlAttributes
  } = props;
  const styledProps = {
    $fullWidth: fullWidth,
    $direction: direction
  };
  const boxProps = {
    p
  };
  return /*#__PURE__*/_jsx(StyledButtonGroup, {
    forwardedAs: as,
    ref: ref,
    ...styledProps,
    ...htmlAttributes,
    ...boxProps
  });
}
export default /*#__PURE__*/React.forwardRef(ButtonGroup);